//var cartToggleClass = $('.site-header__cart'),
var cartToggleClass = $('.js-drawer-open-cart'),
    cartOverlayClass = $('.cart-drawer__overlay');

cartToggleClass.click(function(e){
  e.preventDefault();
  if($('.template-cart').length == 0){
    buildDrawerCart();
    $('.cart__drawer').addClass('cart-drawer__open');
    $('.cart-drawer__overlay').addClass('visible_overlay');
    
//     CHANGED BY HK @16/4 START
    setTimeout(function(){
      $('.cart-drawer_close').click(function(){
        cartOverlayClass.trigger('click');
      });
    },1000);
    
//     CHANGED BY HK @16/4 END
  }
});

function cartDrawerOpen(){
  cartToggleClass.trigger('click');
}

cartOverlayClass.click(function(e){
  e.preventDefault();
  buildDrawerCart();
  
  $('.cart__drawer').removeClass('cart-drawer__open');
  $('.cart-drawer__overlay').removeClass('visible_overlay');
});

function cartDrawerClose(){
  cartOverlayClass.trigger('click');
}

$('form[action="/cart/add"]').on('submit', function(evt) {
  var toAdd = new Array();
  evt.preventDefault();
  var timestamp = Math.round(new Date().getTime()/1000);
  
  var mainVariant = $(this).find('select[name="id"]').val();
  //var mainQty = $(this).find('input[name="quantity"]').val();
  var mainQty = 1;
  
  if($('body').find('.bundleApp .addon-prd').length > 0){
  	toAdd.push({dd_data: 'id='+mainVariant+'&quantity='+mainQty+'&properties%5Bcustom_build%5D=custom-builder'+timestamp+'&properties%5Bmain_product%5D=Yes'});
    $('body').find('.bundleApp .addon-prd input').each(function(){
      if($(this).is(':checked')){
        var addonId = $(this).attr('dataid');
        toAdd.push({dd_data: 'id='+addonId+'&quantity='+mainQty+'&properties%5Bcustom_build%5D=custom-builder'+timestamp});
      }
    });
  } else {
  	toAdd.push({dd_data: 'id='+mainVariant+'&quantity='+mainQty+'&properties%5Bcustom_build%5D=custom-builder'+timestamp+'&properties%5Bmain_product%5D=Yes'});
  }
  
//   moveAlong(toAdd.reverse());
  return false;
});

moveAlong = function(toAdd) {
  //alert(toAdd.length);
  if (toAdd.length) {
    var request = toAdd.shift();
    var tempData = request.dd_data;
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: tempData,
      dataType: 'json',
      success: function(cart) { 
        moveAlong(toAdd);
      },
      error: function() {
        moveAlong(toAdd);
      }
    };
    $.ajax(params);
  } else {
    itemAddedCallback();
  }
}

itemAddedCallback = function (product) {
  cartDrawerOpen();
};

function updateQty(){
  $('.main-prd input[name="updates[]"]').change(function(){
    var toUpdate = "";
    
    var mainpdptimestamp = $(this).parents('.product__item').data('timestamp');
    var mainpdpqty = $(this).val();
    toUpdate += 'updates['+$(this).parents('.product__item').data('itemid')+']='+mainpdpqty+'&';
    
    if(mainpdptimestamp != ""){
      $('form[action="/cart"] .product__item:not(.main-prd)').each(function(){
        if($(this).data('timestamp') ==  mainpdptimestamp){
          $(this).find('input.cart__qty-input').val(mainpdpqty);
          toUpdate += 'updates['+$(this).data('itemid')+']='+mainpdpqty+'&';
        }
      });
    }
    
    var paramsup = {
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: toUpdate.substring(0, toUpdate.length - 1),
      success: function() { 
        buildCart();
      },
      error: function() {
        buildCart();
      }
    };
    $.ajax(paramsup);
    return false;
  });
}

updateQty();

function removeProduct(){
  $('.cart__remove').click(function(e){
    
    var toRemove = "";
    e.preventDefault();
    if($(this).closest('.product__item').hasClass('product__item-addon')){
      toRemove += 'updates['+$(this).parents('.product__item.product__item-addon').data('itemid')+']=0&';
    } else {
      var mainpdptimestamp = $(this).parents('.product__item').data('timestamp');
      toRemove += 'updates['+$(this).parents('.product__item').data('itemid')+']=0&';

      if(mainpdptimestamp != ""){
        $('form[action="/cart"] .product__item:not(.main-prd)').each(function(){
          if($(this).data('timestamp') ==  mainpdptimestamp){
            toRemove += 'updates['+$(this).data('itemid')+']=0&';
          }
        });
      }	
    }
    
    var paramsup = {
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: toRemove.substring(0, toRemove.length - 1),
      success: function() { 
        buildCart();
      },
      error: function() {
        buildCart();
      }
    };
    $.ajax(paramsup);
    return false;
  });
}

removeProduct();

buildCart = function(cart) {
  var $cartHTMLdd = $('form[action="/cart"]');
  $cartHTMLdd.empty();
  var cartHTML = '';
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if (cart.item_count > 0) {
      	if(cartToggleClass.find('.cart-link__bubble').length == 0){
          cartToggleClass.find('.cart-link__bubble').addClass('cart-link__bubble--visible').text(cart.item_count)
        }
        else{
          cartToggleClass.find('.cart-link__bubble').addClass('cart-link__bubble--visible').text(cart.item_count)
        }
        cartHTML += '<div class="cart__table">';
        cartHTML += '<div class="cart__row-head"><div class="cart__tr">';
        cartHTML += '<div class="cart__th cart__th-img">Product</div>';
        cartHTML += '<div class="cart__th cart__th-des">Description</div>';
        cartHTML += '<div class="cart__th cart__th-qty text-center">Quantity</div>';
        cartHTML += '<div class="cart__th cart__th-total text-right">Total</div>';
        cartHTML += '</div></div>';
      	cartHTML += '<div class="cart__row-body"><div class="cart__tr">';
        $.each(cart.items, function(index, cartItem) {
          if(cartItem.properties !== null && cartItem.properties!== undefined && cartItem.properties.main_product){
          	var productType = ' main-prd'; 
            var hideAddon = '';
          } else{
          	var productType = ' product__item-addon';
            var hideAddon = ' hide';
          }
          if(cartItem.properties !== null && cartItem.properties!== undefined && cartItem.properties.custom_build){
          	var customBuild = ' data-timestamp="'+cartItem.properties.custom_build+'"';            
          } else{
          	var customBuild = '';
          }
          if (cartItem.image != null){
            var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_95x95$1").replace('http:', '');
          } else {
            var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
          }
          cartHTML += '<div class="product__item'+productType+'" data-itemid="'+cartItem.id+'"'+ customBuild +'>';
          	cartHTML += '<div class="cart__td cart__th-img"><div>';
          	  cartHTML += '<img class="cart-item__image" src="'+prodImg+'" alt="'+cartItem.product_title+'" data-item-url="'+cartItem.url+'" style="cursor: pointer;">';
          	cartHTML += '</div></div>';
          
          	cartHTML += '<div class="cart__td cart__th-des">';
          	cartHTML += '<div class="cart-item__title">';
          		cartHTML += '<a href="'+cartItem.url+'">'+cartItem.title+'</a>';
          	cartHTML += '</div>';
          
            if(cartItem.properties !== null && cartItem.properties!== undefined){
              cartHTML += '<div class="cart-item__meta">';
              $.each(cartItem.properties, function(index, cartItemProperties) {
                cartHTML += index + ': ' +cartItemProperties+'<br>';
              });
              cartHTML += '</div>';
            }
          
          	cartHTML += '<a href="javascript:void(0);" class="cart-item__remove cart__remove">Remove</a>';            
          	cartHTML += '</div>';                
            cartHTML += '<div class="cart__td cart__th-qty text-center'+hideAddon+'"><div class="cart-item__qty">';            
            cartHTML += '<input class="cart-item__qty-input cart__qty-input" type="number" name="updates[]" value="'+cartItem.quantity+'" min="1" pattern="[0-9]*" data-quantity-item="'+cartItem.quantity+'">';
            cartHTML += '</div></div>';
            
          	cartHTML += '<div class="cart__td cart__th-total text-right">'+theme.Currency.formatMoney(cartItem.line_price, theme.settings.moneyFormat)+'</div>';
          cartHTML += '</div>';
        });
      	cartHTML += '</div></div>';
      cartHTML += '</div>';
      
      cartHTML += '<div class="cart__footer">';
        cartHTML += '<div class="grid">';
      	
      	cartHTML += '<div class="grid__item text-right small--text-center">';
            cartHTML += '<div>';
              cartHTML += '<span class="cart__subtotal-title">Subtotal</span>';
              cartHTML += '<span class="cart__subtotal">'+theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat)+'</span>';
            cartHTML += '</div>';
            
			cartHTML += '<div class="cart__shipping rte">Taxes and shipping calculated at checkout</div>';
            cartHTML += '<div class="cart__submit-controls">';
              cartHTML += '<input type="submit" name="update" class="btn btn--secondary small--hide cart__submit-control" value="Update cart">';
              cartHTML += '<input type="submit" name="checkout" class="btn btn--small-wide cart__submit cart__submit-control" value="Check out">';
            cartHTML += '</div>';           
          cartHTML += '</div>';
      
      
      	cartHTML += '</div>';
      cartHTML += '</div>';
      
      
      $cartHTMLdd.append(cartHTML);
      
      updateQty();
      
      removeProduct();
      
    }
    else{
      /*
      if(cartToggleClass.find('.cart-link__bubble').length > 0){
      	cartToggleClass.find('.cart-link__bubble').css('display','none');
      }*/
      if(cartToggleClass.find('.cart-link__bubble').length > 0){
      	cartToggleClass.find('.cart-link__bubble').removeClass('cart-link__bubble--visible')
      }
      
      $cartHTMLdd.siblings('.section-header').remove();
      cartHTML += '<div class="empty-page-content text-center">';
      	cartHTML += '<h1>Your cart</h1>';
        cartHTML += '<p class="cart--empty-message">Your cart is currently empty.</p>';
        cartHTML += '<a href="/" class="btn btn--has-icon-after cart__continue-btn">Continue shopping<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"/></svg></a>';
      cartHTML += '</div>';
                 
      $cartHTMLdd.append(cartHTML);
    }
  });
}

buildCart();

///// drawer code /////

function updateDrawerQty(){
  $('.main-drwr-prd input[name="updates[]"]').change(function(){
    var toUpdate = "";
    
    var mainpdptimestamp = $(this).parents('.cart__drawer-product').data('timestamp');
    var mainpdpqty = $(this).val();
    toUpdate += 'updates['+$(this).parents('.cart__drawer-product').data('itemid')+']='+mainpdpqty+'&';
    
    if(mainpdptimestamp != ""){
      $('.cart__drawer-product:not(.main-drwr-prd)').each(function(){
        if($(this).data('timestamp') ==  mainpdptimestamp){
          $(this).find('input.cart-item__qty-input').val(mainpdpqty);
          toUpdate += 'updates['+$(this).data('itemid')+']='+mainpdpqty+'&';
        }
      });
    }
    var paramsup = {
      type: "POST",
      url: "/cart/update.js",
      dataType: "json",
      data: toUpdate.substring(0, toUpdate.length - 1),
      success: function() { 
        buildDrawerCart();
      },
      error: function() {
        buildDrawerCart();
      }
    }
    $.ajax(paramsup);
    return false;
    
  });
}

updateDrawerQty();

function removeDrawerProduct(){
  $('.cart-drawer__remove').click(function(e){
    var toRemove = "";
    e.preventDefault();
    if($(this).closest('.cart__drawer-product').hasClass('cart__drawer-product-addon')){
      toRemove += 'updates['+$(this).parents('.cart__drawer-product.cart__drawer-product-addon').data('itemid')+']=0&';
    } else {
      var mainpdptimestamp = $(this).parents('.cart__drawer-product').data('timestamp');
      toRemove += 'updates['+$(this).parents('.cart__drawer-product').data('itemid')+']=0&';

      if(mainpdptimestamp != ""){
        $('.cart__drawer-product:not(.main-drwr-prd)').each(function(){
          if($(this).data('timestamp') ==  mainpdptimestamp){
            toRemove += 'updates['+$(this).data('itemid')+']=0&';
          }
        });
      }	
    }
    
    var paramsup = {
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: toRemove.substring(0, toRemove.length - 1),
      success: function() {         
        buildDrawerCart();
      },
      error: function() {
        buildDrawerCart();
      }
    };
    $.ajax(paramsup);
    return false;
  });
}

removeDrawerProduct();

buildDrawerCart = function(cart) {
  var $cartDrawer = $('.cart__drawer');
  $cartDrawer.empty();
  var cartDrwaerHTML = '';
  
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if(cart.item_count > 0) {
      
      if(cartToggleClass.find('.cart-link__bubble').length == 0){
        cartToggleClass.find('.cart-link__bubble').addClass('cart-link__bubble--visible').text(cart.item_count)
      }
      else{
        cartToggleClass.find('.cart-link__bubble').addClass('cart-link__bubble--visible').text(cart.item_count)
      }
      
      cartDrwaerHTML += '<div class="cart__drawer-head"><h2><a href="/cart">Your Cart</a></h2>';
      cartDrwaerHTML += '<div class="cart-drawer_close"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><defs><style>.cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}</style></defs><path class="cls-1" d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg></div>';
      cartDrwaerHTML += '</div>';
      cartDrwaerHTML += '<div class="cart__drawer-content"><div class="cart__drawer-table"><div class="cart__drawer-table_inner"><div class="cart__row-body"><div class="cart__drawer-row">';
      $.each(cart.items, function(index, cartDrawerItem) {
        
        if(cartDrawerItem.properties !== null && cartDrawerItem.properties !== undefined && cartDrawerItem.properties.main_product){
          var productType = ' main-drwr-prd'; 
          var hideAddon = '';
        } else{
          var productType = ' cart__drawer-product-addon';
          var hideAddon = ' hide';
        }

        if(cartDrawerItem.properties !== null && cartDrawerItem.properties !== undefined && cartDrawerItem.properties.custom_build){
          var customBuild = ' data-timestamp="'+cartDrawerItem.properties.custom_build+'"';            
        } else{
          var customBuild = '';
        }

        if (cartDrawerItem.properties !== null && cartDrawerItem.properties !== undefined && cartDrawerItem.image != null){
          var prodDrImg = cartDrawerItem.image.replace(/(\.[^.]*)$/, "_95x95$1").replace('http:', '');
        } else {
          var prodDrImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }        
        cartDrwaerHTML += '<div class="cart__drawer-product'+productType+'" data-itemid="'+cartDrawerItem.id+'"'+ customBuild +'>';
        cartDrwaerHTML += '<div class="cart__drawer-img"><div>';
        cartDrwaerHTML += '<img class="cart-item__image" src="'+prodDrImg+'" alt="'+cartDrawerItem.product_title+'" data-item-url="'+cartDrawerItem.url+'" style="cursor: pointer;">';
        cartDrwaerHTML += '</div></div>';
        cartDrwaerHTML += '<div class="cart__drawer-des">';
        cartDrwaerHTML += '<div class="cart-item__title"><a href="'+cartDrawerItem.url+'">'+cartDrawerItem.title+'</a></div>';
        cartDrwaerHTML += '<a href="javascript:void(0);" class="cart-item__remove cart-drawer__remove">Remove</a>';
        cartDrwaerHTML += '<div class="cart__drawer-meta">';
        cartDrwaerHTML += '<div class="cart__drawer-qty'+hideAddon+'"><div class="cart-item__qty">';
        cartDrwaerHTML += '<input class="cart-item__qty-input" type="number" name="updates[]" value="'+cartDrawerItem.quantity+'" min="1" pattern="[0-9]*" data-quantity-item="'+cartDrawerItem.quantity+'">';
        cartDrwaerHTML += '</div></div>';
        cartDrwaerHTML += '<div class="cart__drawer-total">'+theme.Currency.formatMoney(cartDrawerItem.line_price, theme.settings.moneyFormat)+'</div>';
        cartDrwaerHTML += '</div>';          
        cartDrwaerHTML += '</div>';
        cartDrwaerHTML += '</div>';
      });
      cartDrwaerHTML += '</div></div></div></div></div>';
      cartDrwaerHTML += '<div class="cart__drawer-footer">';
      cartDrwaerHTML += '<div class="cart-total__wrap grid grid--full"><div class="grid__item two-thirds"><span class="cart-total__title">SUBTOTAL</span></div><div class="grid__item one-third text-right"><span class="cart__total">'+theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat)+'</span></div></div>';
      cartDrwaerHTML += '<p class="ajaxcart__note">Shipping, taxes, and discounts calculated at checkout.Orders will be processed in USD.</p>';
      cartDrwaerHTML += '<a href="/checkout" class="btn btn__checkout">Checkout</a>';
      cartDrwaerHTML += '</div>';
    } else {
      if(cartToggleClass.find('.cart-link__bubble').length > 0){
      	cartToggleClass.find('.cart-link__bubble').removeClass('cart-link__bubble--visible');
      }
      cartDrwaerHTML += '<div class="cart__drawer-head"><h2><a href="/cart">Your Cart</a></h2>';
      cartDrwaerHTML += '<div class="cart-drawer_close"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><defs><style>.cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}</style></defs><path class="cls-1" d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg></div>';
      cartDrwaerHTML += '</div>';
      cartDrwaerHTML += '<div class="cart__drawer-content"><div class="cart__drawer-table"><div class="cart__drawer-table_inner"><div class="cart__row-body">';
      cartDrwaerHTML += '<p class="cart--empty-message">Your cart is currently empty.</p>';
      cartDrwaerHTML += '</div></div></div></div>';
    }
    $cartDrawer.empty();
    $cartDrawer.append(cartDrwaerHTML);
    
    updateDrawerQty();
    removeDrawerProduct();
     $('.cart-drawer_close').click(function(){
        cartOverlayClass.trigger('click');
      });
  });
}
buildDrawerCart();

$(document).ready(function(){
  var screensize = document.documentElement.clientWidth;
  
  if($('.var_iframe').length > 0){
    if($('.variant-input-wrap[name=Colour]').length > 0){
      //console.log($('.variant-input-wrap[name=Colour] .dd-var[checked=checked]').val());
      var color = $('.variant-input-wrap[name=Colour] .dd-var[checked=checked]').val().toLowerCase();

      if($('.var_iframe').find('.vars[data-color='+color+']').length > 0){
        var iframe_val = $('.var_iframe').find('.vars[data-color='+color+']').attr("data-iframe");
        var iframe_html = '<div class="rotate_imgproduct_image_kd medium-up--one-whole colored_image"><div class="product-image-main"><div class="image-wrap iframe"><iframe src="'+iframe_val+'" width="640" height="640" scrolling="no" style="max-width:100%; max-height:100vw;"></iframe></div></div></div>';
        $('.img-slider').prepend(iframe_html);
      }
    }
  }
  
//   console.log($('.img-slider[data-slider-style="horizontal"]').length);
  if($('.img-slider[data-slider-style="horizontal"]').length == 1){
  
    $('.img-slider').slick({
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true
    });
  }
  else{
    if(screensize < 736)
    {
      $('.img-slider').slick({
        dots: true,
        vertical: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        verticalSwiping: true,
        infinite: false,
        adaptiveHeight: true,
        arrows: false
      });

      //     $('.img-slider').on('afterChange', function(event, slick, currentSlide) {

      //       if (slick.$slides.length-1 == currentSlide) {
      //         console.log("Last slide");
      //       }
      //     });
    }
  }
  
  $(".tab-slider--body").hide();
  $(".tab-slider--body:first").show();

  $(".tab-slider--nav li").click(function() {
    $(".tab-slider--body").hide();
    var activeTab = $(this).attr("rel");
    $("#"+activeTab).fadeIn();
    if($(this).attr("rel") == "tab2"){
      $('.tab-slider--tabs').addClass('slide');
    }else{
      $('.tab-slider--tabs').removeClass('slide');
    }
    $(".tab-slider--nav li").removeClass("active");
    $(this).addClass("active");
  });
  
  
  
  $('.img-new-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    adaptiveHeight: true
  });
  
});
